// KYC status vocabularies — each mirrors a distinct backend enum, surfaced by a
// distinct endpoint. They are NOT interchangeable: a value valid for one
// endpoint never appears on another, so each consumer must compare against the
// constant for the endpoint it actually reads.
//
//   ACCOUNT_KYC_STATUS    ← GET /api/dashboard/profile/status  .kycStatus
//                           (BE enum AccountKycStatus — aggregate account view)
//   KYC_SUBMISSION_STATUS ← GET /api/kyc/status                .kycStatus
//                           (BE enum KycStatus — raw submission state, lowercase)
//
// GET /api/kyc/details emits a third vocabulary (BE enum KycDisplayStatus:
// PENDING/IN_PROGRESS/KYC_REQUIRED/KYC_UNDER_REVIEW/APPROVED/REJECTED/
// KYC_NOT_REQUIRED). No FE code compares against it today — ProfileContainer
// derives its KYC display from the dashboard-state resolver, not from the
// detail string — so no constant is defined for it. Add one here if a consumer
// ever needs to branch on the /kyc/details status.

// Aggregate account-level KYC status — the only KYC vocabulary that gates the
// dashboard state machine and financial actions.
export const ACCOUNT_KYC_STATUS = {
  NO_KYC_REQUIRED: 'NO_KYC_REQUIRED',
  PENDING: 'KYC_PENDING',
  IN_REVIEW: 'KYC_IN_REVIEW',
  COMPLETED: 'KYC_COMPLETED',
  REQUIRED: 'KYC_REQUIRED',
} as const

export type AccountKycStatusValue = (typeof ACCOUNT_KYC_STATUS)[keyof typeof ACCOUNT_KYC_STATUS]

// Raw KYC submission status from the lightweight /kyc/status endpoint. Values
// are lowercase (the backend KycStatus enum verbatim). Consumed by the
// onboarding wizard (resume point) and the mobile-nav verified badge.
export const KYC_SUBMISSION_STATUS = {
  PENDING: 'pending',
  IN_PROGRESS: 'in_progress',
  PENDING_REVIEW: 'pending_kyc_review',
  APPROVED: 'approved',
  REJECTED: 'rejected',
  REVERIFY: 'reverify',
  EXPIRED: 'expired',
} as const

export type KycSubmissionStatusValue =
  (typeof KYC_SUBMISSION_STATUS)[keyof typeof KYC_SUBMISSION_STATUS]
